import './Navbar.scss';
import { Component } from '@components/Component/Component.js';
import DIContainer, { getInstance } from '@components/DependencyInjectionContainer.js';
import { ButtonsMixin } from '@components/Mixin/ButtonsMixin/ButtonsMixin.js';
import { ContextMenuMixin } from '@components/Mixin/ContextMenuMixin/ContextMenuMixin.js';
import { ENV } from '@components/Environment.js';
export class Navbar extends ButtonsMixin(ContextMenuMixin(Component)) {
    constructor() {
        super(...arguments);
        this.componentName = 'Navbar';
        this._includeLogo = true;
        this._title = '';
    }
    get includeLogo() { return this._includeLogo; }
    set includeLogo(value) {
        this._propertySet('includeLogo', value);
        this.renderLogo();
    }
    get title() { return this._title; }
    set title(value) {
        this._propertySet('title', value ?? '');
        this.updateTitleUI();
    }
    get ScreenManager() {
        if (!this.dependencies.ScreenManager) {
            return DIContainer.getInstance('ScreenManager');
        }
        return this.dependencies.ScreenManager;
    }
    draw() {
        super.draw();
        this.rootElement?.classList.add('s360Navbar');
        if (!this.includeLogo) {
            this.renderLogo();
        }
        this.updateTitleUI();
        this.addApplicationMenuButtons();
    }
    renderLogo() {
        if (!this.drawn)
            return;
        const logoContainer = this.rootElement?.querySelector('.navbar-logo');
        logoContainer?.classList.toggle('d-none', !this._includeLogo);
    }
    updateTitleUI() {
        const container = this.rootElement?.querySelector('.navbar-form-title');
        const el = this.rootElement?.querySelector('.title-bar h3');
        if (el) {
            el.textContent = this._title;
        }
        container?.classList.toggle('d-none', !this._title);
    }
    buttonContainerCreate() {
        const rightMenu = this.rootElement.querySelector('.navbar-right>.navbar-button-container');
        if (rightMenu) {
            this.buttonContainers.set('right-menu', rightMenu);
        }
        const leftMenu = this.rootElement.querySelector('.navbar-left>.navbar-button-container');
        if (leftMenu) {
            this.buttonContainers.set('left-menu', leftMenu);
        }
    }
    addApplicationMenuButtons() {
        const app = getInstance('Application');
        const userItems = app.getUserMenuItems?.() ?? [];
        const helpItems = app.getHelpMenuItems?.() ?? [];
        const devItems = app.getDevMenuItems?.() ?? [];
        if (devItems.length) {
            this.buttonAdd({
                icon: 'build_circle',
                id: 'rightmenu_dev_btn',
                containerId: 'right-menu',
                classList: ['nav-button'],
                onClick: (e) => this.menuClickHandler('dev', e)
            });
        }
        if (helpItems.length) {
            this.buttonAdd({
                icon: 'help',
                id: 'rightmenu_help_btn',
                containerId: 'right-menu',
                classList: ['nav-button'],
                captionKey: 'system_navbar_helpmenu',
                onClick: (e) => this.menuClickHandler('help', e)
            });
        }
        if (userItems.length) {
            this.buttonAdd({
                caption: ENV('userName') || '',
                icon: 'account_circle',
                id: 'rightmenu_user_btn',
                containerId: 'right-menu',
                classList: ['nav-button'],
                captionKey: 'system_navbar_usermenu',
                onClick: (e) => this.menuClickHandler('user', e)
            });
        }
    }
    menuClickHandler(menu, event) {
        let button = event.target;
        while (button.parentNode && !button.classList.contains('nav-button')) {
            button = button.parentNode;
        }
        if (button) {
            const rect = button.getBoundingClientRect();
            const contextInfo = {
                targetElement: button,
                x: rect.right,
                y: rect.bottom,
                event: event,
                menu: menu,
                anchorPosition: 'top-right',
                initiator: this
            };
            const items = this.getContextMenuItems(contextInfo);
            if (items?.length) {
                this.ContextMenu.showMenu(items, contextInfo, `${this.globalId}_${menu}`);
            }
        }
    }
    getContextMenuItems(contextInfo) {
        const app = getInstance('Application');
        switch (contextInfo.menu) {
            case 'user': return app.getUserMenuItems?.() ?? [];
            case 'help': return app.getHelpMenuItems?.() ?? [];
            case 'dev': return app.getDevMenuItems?.() ?? [];
        }
        return [];
    }
    template() {
        return `<nav class="navbar">
	<div class="navbar-container navbar-left">
		<span class="navbar-button-container"></span>
	</div>
	<div class="navbar-container navbar-logo">
		<span class="branding-logo"></span>
	</div>
	<div class="navbar-container navbar-form-title title-bar d-none">
		<h3></h3>
	</div>
	<div class="navbar-container navbar-right">
		<span class="navbar-button-container"></span>
	</div>
</nav>`;
    }
}
Navbar.VERSION = '$Revision: 130768 $';
